import { EsignDocumentPreviewModal } from "@/pages/esign/widgets/EsignDocumentPreviewModal.tsx";
import { useDocument } from "@/queries/use-documents.query.ts";
import { Avatar, FontAwesomeIcon, ListItem, Stack, Title, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface EsignDocumentRowProps {
  documentId: number;
  documentTitle: string;
  showFields?: boolean;
}

export function EsignDocumentRow({ documentId, documentTitle, showFields }: EsignDocumentRowProps) {
  const { t } = useTranslation();
  const { openModal } = useModals();
  const { data: doc } = useDocument(documentId);

  const handleOpen = () => {
    if (!doc?.file) return;
    openModal(EsignDocumentPreviewModal, {
      documentId,
      file: doc.file,
      fileName: doc.file.name,
      preview: doc.preview,
      showFields,
    });
  };

  return (
    <Stack>
      <Title header={t("core:document")} size="xs" />
      <ListItem
        icon={<Avatar icon={<FontAwesomeIcon icon="fa-light fa-file" />} size="md" />}
        title={doc?.title ?? documentTitle}
        caption={doc?.file?.name}
        valueSlot={<FontAwesomeIcon icon="fa-light fa-chevron-right" />}
        onClick={handleOpen}
      />
    </Stack>
  );
}
